/**
 *
 * AskAudioPermissionButton
 *
 */

import React from 'react';
// import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { Link, useHistory } from 'react-router-dom';

// styles
import './style.scss';

// import useDeviceDetect from 'utils/useDeviceDetect';

// antd component
//import { Card } from 'antd';
//const { Meta } = Card;

// icons
//import CustomIcons from 'components/CustomIcons';
//import defaultUnitImage from 'images/default.jpg';

// components
import LinkWrapper from 'components/LinkWrapper';

// global user
// import { withUser } from 'engine/Contexts/User.context';

function AskAudioPermissionButton({
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames(
    'AskAudioPermissionButton-wrapper',
    className,
  );
  //const { isMobile } = useDeviceDetect();

  return <div className={childClassNames} />;
}

AskAudioPermissionButton.defaultProps = {};
AskAudioPermissionButton.propTypes = {};

export default AskAudioPermissionButton;
